import * as yup from 'yup';

export const USERNAME_REGEX = /[A-z0-9_]+/;
export const USERNAME_MAXIMUM = 15;

export const PASSWORD_MINIMUM = 8;

export const USERNAME_SCHEMA = yup
  .string()
  .required('Username is required')
  .matches(
    USERNAME_REGEX,
    'Username can only contain letters, numbers and underscores',
  )
  .max(
    USERNAME_MAXIMUM,
    `Username can only be ${USERNAME_MAXIMUM} characters long`,
  );

export const PASSWORD_SCHEMA = yup
  .string()
  .required('Password is required')
  .min(
    PASSWORD_MINIMUM,
    `Password must be at least ${PASSWORD_MINIMUM} characters long`,
  );
